import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {Row, Col, Media, UncontrolledCollapse } from 'reactstrap';
import videoIcon from '../../../images/socialIcons/videocall.png';
import instagramIcon from '../../../images/socialIcons/instagramicon.png';
import analytic from '../../../images/socialIcons/analytics.png';
import scheduleIcon from '../../../images/socialIcons/scheduleicon.png';
import threedotIcon from '../../../images/socialIcons/threedot.png';
import addPlus from '../../../images/socialIcons/add-plus.png';
import { UncontrolledTooltip } from 'reactstrap';



import relayStreamLogo from '../../../relaystream-logo.png';
import './SidebarMenu.css';
import { translate } from 'react-i18next';

class SidebarMenu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      channelAngleToggle: false,
      mediaAngleToggle:false,
      scheduleAngleToggle:false,
      userAngleToggle:false,
      shortSideBar: false,
      logoIcon: localStorage.getItem('username') ? localStorage.getItem('username').charAt(0).toUpperCase() : 'R'
    };

  }

  componentDidMount = () =>{
   
  }


  channelToggle=()=>{
    this.setState({
      channelAngleToggle: !this.state.channelAngleToggle
    });
  }

  mediaToggle=()=>{
    this.setState({
      mediaAngleToggle: !this.state.mediaAngleToggle
    });
  }
  

  scheduleToggle=()=>{
    this.setState({
      scheduleAngleToggle: !this.state.scheduleAngleToggle
    });
  }

  userToggle=()=>{
    this.setState({
      userAngleToggle: !this.state.userAngleToggle
    });
  }
  render() {
    return (
      <div>
      {/* {this.state.shortSideBar? */}
      <aside className="DashboardPage__sidebar collapse" id="DashboardPage-sidebar">
          <img className="DashboardPage__sidebar__logo mb-4" src={relayStreamLogo} alt="relaystream logo" />
          <Media list className="p-0 sidebar-menu">
            <Media tag="li" className="active align-items-start py-3">
              <Media left middle tag="span" className="media-img media-img--dashboard mx-3 " />
                <Media body className=" text-sm-left mb-3 mb-sm-0">
                  <Media heading tag="h6" className="heading-tag">
                    <NavLink to={'/dashboard'} className="media-link">Dashboard</NavLink>
                  </Media>
                </Media>
              </Media>
            <Media tag="li" className="active align-items-start py-3">
              <Media left middle tag="span" className="media-img media-img--dashboard mx-3 " />
                <Media body className="text-sm-left mb-3 mb-sm-0">
                  <Media heading tag="h6" className="heading-tag">
                    <NavLink activeClassName="active" to={'/dashboard'} className="media-link">UserAccount</NavLink>
                  </Media>
                </Media>
              </Media>
          </Media>
        </aside>
        <aside id="shortSidebarMenu" className="Sticky_sidebar collapse show">
          <Media list className="p-0 sidebar-menu">
            <Media tag="li" className="active align-items-start">
            <NavLink activeClassName="active" to={'/dashboard/account'} className="media-link">
            {/* <Media object src={relayIcon} className='relayIcon'/> */}
            <button className='nameIcon relayIcon'><b>{this.state.logoIcon}</b></button>
            </NavLink>
            </Media>
            <Media tag="li" className="active align-items-start">
            <NavLink activeClassName="active" to={'/dashboard/main'} className="media-link">
            <Media id="dashboard" object src={videoIcon} className='videoIconImage'/>
            </NavLink>
            <UncontrolledTooltip placement="right" target="dashboard">
                Multitransmissão
            </UncontrolledTooltip>
            </Media>

            {/* <Media tag="li" className="active align-items-start py-1">
            <NavLink activeClassName="active" to={'/dashboard/instagram/rtmp'}>
            <Media id="chatlink" object src={instagramIcon} className='videoIconImage chatIcons'/>
            </NavLink>
            <UncontrolledTooltip placement="right" target="chatlink">
              Comentários
            </UncontrolledTooltip>
            </Media> */}

            {/* <Media tag="li" className="active align-items-start py-1">
            <NavLink activeClassName="active" to={'/dashboard/history'} className="media-link">
            <Media id="history" object src={chartIcon} className='videoIconImage'/>
            </NavLink>
            <UncontrolledTooltip placement="right" target="history">
                História
            </UncontrolledTooltip>
            </Media> */}

            <Media tag="li" className="active align-items-start py-1">
            <NavLink activeClassName="active" to={'/dashboard/schedule/broadcast'} className="media-link">
            <Media id="schedule" object src={scheduleIcon}  className='videoIconImage'/>
            </NavLink>
            <UncontrolledTooltip placement="right" target="schedule">
                Programação de transmissão 
            </UncontrolledTooltip>
            </Media>

            <Media tag="li" className="active align-items-start py-1">
            <NavLink activeClassName="active" to={'/dashboard/social/statistics'} className="media-link">
            <Media id="connection" object src={analytic}  className='videoIconImage'/>
            </NavLink>
            <UncontrolledTooltip placement="right" target="connection">
                Conexões 
            </UncontrolledTooltip>
            </Media>

            <Media tag="li" className="active align-items-start py-1">
            <NavLink activeClassName="active" to={'/dashboard/social/platform'} className="media-link">
            <Media id="addChannel" object src={addPlus}  className='videoIconImage'/>
            </NavLink>
            <UncontrolledTooltip placement="right" target="addChannel">
                Adicionar Canal 
            </UncontrolledTooltip>
            </Media>

            <Media tag="li" className="active align-items-start py-1">
            <Media id="more" object src={threedotIcon} className='videoIconImage chatIcons'/>
            <UncontrolledTooltip placement="right" target="more">
                Mais
            </UncontrolledTooltip>
            </Media>
          </Media>

          
      </aside>
    {/* } */}
    </div>
    );
  }
}
export default translate('translations')(SidebarMenu);



// WEBPACK FOOTER //
// ./src/components/DashboardPage/SidebarMenu/SidebarMenu.js